'use client';

import { PropsWithChildren } from 'react';
import styles from './MobileResultsList.module.scss';

type Props = {};

const MobileResultsList = ({ children }: PropsWithChildren<Props>) => <div className={styles.mobileTrailList}>{children}</div>;

export default MobileResultsList;
